import React from 'react'
import { PageFactory } from './Page'
import Ministries from '../components/Ministries'

const BasePost = PageFactory({
  renderers: {
    Ministries,
  },
})

const MinistriesPage = props => <BasePost {...props} which="ministries" />

export default MinistriesPage
